import { Grid } from "@material-ui/core"
import React from "react"
import ImageComponent from "./../ImageComponent";
import HeroText from "./heroText";



const HeroContent = ({heroTitle, heroContent, fileName, altText}) => {

    return(
        <div>
            <Grid container spacing={4} >
                <Grid item md={6} sm={6} xs={12} style={{padding:'32px'}}>
<ImageComponent fileName={fileName} alt={altText} style={{width:'100%',}}
/>
                </Grid>
                <Grid item md={6} sm={6} xs={12}>
          <HeroText heroTitle={heroTitle} heroContent={heroContent} buttons />
        
                </Grid>
        </Grid>
        </div>
    )
}

export default HeroContent